<template>
    <DCard
        padding
    >
        <DTable
            :items="invoiceDeliveryTypes"
            :fields="[
                {key: 'value', label: __('settings.invoice_delivery_types.invoice_delivery_type')},
                {key: 'isActive', label: __('settings.invoice_delivery_types.active'), sorter: false, filter: false},
                {key: 'actions', label: '', sorter: false, filter: false}
            ]"
            hover
            sorter
        >
            <template #isActive="{item}">
                <td>
                    <DBadge :color="item.isActive ? 'success' : 'danger'">
                        {{
                            item.isActive ? __('settings.invoice_delivery_types.is_active.yes') : __('settings.invoice_delivery_types.is_active.no')
                        }}
                    </DBadge>
                </td>
            </template>
            <template #value="{item}">
                <td>
                    {{
                        __('settings.invoice_delivery_types.type.' + item.value)
                    }}
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="router.get(editLink(item.id))"
                        />
                    </div>
                </td>
            </template>
        </DTable>
    </DCard>
</template>

<script setup>

import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'

defineProps({
    invoiceDeliveryTypes: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function editLink (id) {
    return route('settings.invoice-delivery-types.edit', { invoice_delivery_type: id })
}
</script>
